import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
@Component({
  name: 'bpc-time-range',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class TimeRange extends mixins(AbstractField) {
  @Prop(Object) readonly value: { start_time: string; end_time: string };

  get model(): { start_time: string; end_time: string } {
    return this.value;
  }
  set model(val: { start_time: string; end_time: string }) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get minutes(): number {
    if (this.model.start_time && this.model.end_time) {
      if (this.eventsConfig && this.eventsConfig.emit) {
        this.eventsConfig.emit.forEach(event => {
          this.$root.$emit(event);
        });
      }

      const startDate = moment('2000-01-10 ' + this.model.start_time, 'YYYY-MM-DD hh:mm');
      const endDate = moment('2000-01-10 ' + this.model.end_time, 'YYYY-MM-DD hh:mm');
      return endDate.diff(startDate, 'minutes');
    }
    return 0;
  }
  get hours(): number[] {
    const start_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_start_hour?.slice(0, 2) || '7';
    const end_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_end_hour?.slice(0, 2) || '22';
    return Array.from({ length: parseInt(end_hour) - parseInt(start_hour) + 1 }).map(
      (_, i) => i + parseInt(start_hour),
    );
  }
}
